import { Annotation } from '../objects/Annotation.interface';
import { Entity } from '../objects/Entity.interface';
import { DOCUMENTS_REPLACER, EXPORT_FORMAT_NER, EXPORT_FORMAT_TAGTOG } from './Contants';
import { entityItem, NERAnnotation } from '../interfaces/NERAnnotation.interface';
import JSZip from 'jszip';
import { Document } from '../objects/Document.interface';
import { buildTagTogFieldsJSON, readBinaryContent, removeBreakLine } from './Utils';
import { Field } from '../objects/Field.interface';
import { Project } from '../objects/Project.interface';

export class ExportData{

    startExportEntitiesData(entities: Entity[], project:Project){
        var stringJSON = this.createJSONENTITIESANNFile(project,entities, DOCUMENTS_REPLACER);
        this.dowloadFile(stringJSON, 'entities-legends.json', 'application/json');
    }

    startExportFieldsData(fields: Field[]|undefined){
        let FieldList: any = [];
        if(fields !== undefined){
            fields.forEach(item =>{
                FieldList.push({
                    id: item.id!,
                    name: item.name,
                    code: item.code,
                    selected: true
                });
            });
        }

        return FieldList;
    }

    startExportProcess (formatExport:number, annotations: Annotation[], entities: Entity[], documents: Document[]){
        const zip = new JSZip();
        var prefix = '';
        documents.forEach(document => {

            if(formatExport == EXPORT_FORMAT_NER){
                prefix = 'NER';
                const jsonStringify = this.createJSONFile(annotations.filter(annotation => annotation.documentId === document.id), entities, document, DOCUMENTS_REPLACER);
                zip.folder('data_NER_export_anotations')!.folder("NER_Annotations")!.file(document.title+'.json',jsonStringify);
            }

            if(formatExport == EXPORT_FORMAT_TAGTOG){
                prefix ='GTA';
                const htmlFile = this.createHTMLTAGTOGFile(document);
                zip.folder('data_GTA_export_anotations')!.folder("GTA_Documents")!.file(document.title.replace('txt','plain')+'.html',htmlFile);
                
                const jsonStringify = this.createJSONTAGTOGFile(annotations.filter(annotation => annotation.documentId === document.id), entities, document, DOCUMENTS_REPLACER);
                zip.folder('data_GTA_export_anotations')!.folder("GTA_Documents")!.file(document.title.replace('txt','ann')+'.json',jsonStringify);

                const jsonEntitiesStringify = this.createJSONENTITIESTAGTOGFile(entities,DOCUMENTS_REPLACER);
                zip.folder('data_GTA_export_anotations')!.file('annotations-legend.json',jsonEntitiesStringify);
            }

        });


        this.createZipFile(zip, prefix);
    }

    exportProject(annotations: Annotation[], entities: Entity[], documents: Document[], project:Project){
        const zip = new JSZip();

        documents.forEach(document => {
            const txtFile = readBinaryContent(document.textContent)
            zip.folder('data_ANN_export_anotations')!.folder("ANN_Documents")!.file(document.title,txtFile);

            const jsonStringify = this.createJSONANNFile(annotations.filter(annotation => annotation.documentId === document.id && annotation.status === 'Saved'), document, DOCUMENTS_REPLACER);
                zip.folder('data_ANN_export_anotations')!.folder("ANN_Documents")!.file(document.title.replace('txt','ann')+'.json',jsonStringify);

            const jsonEntitiesStringify = this.createJSONENTITIESANNFile(project,entities, DOCUMENTS_REPLACER);
            zip.folder('data_ANN_export_anotations')!.file('annotations-legend.json',jsonEntitiesStringify);
        });
        this.createZipFile(zip,'ANNOTATOR');
    }

    private createJSONENTITIESTAGTOGFile(entities:Entity[], replacer:any):string{
        var entitiesValues: string = '{ ';

        entities.forEach(entity => {
            entitiesValues += ' "'+entity.Code + '" : "'+removeBreakLine(entity.Entity)+'" ,' ;
            
            
            entity.FieldList?.forEach(field => {
                if(!field.code.includes('WOF'))
                    entitiesValues += ' "'+field.code + '" : "'+removeBreakLine(field.name)+'" ,' ;

            });
        });
        entitiesValues = entitiesValues.substring(0,entitiesValues.length-1);
        entitiesValues += ' }';
        return entitiesValues;
    }

    private createJSONENTITIESANNFile (project:Project,entities:Entity[], replacer:any):string{
        var EntityList: any = [];

        var dataProjectJson = {
            name: project.name,
            description: project.description,
            entities: []
        };
        entities.forEach(item =>{
            var entityItem: any = {
                entity: item.Entity,
                code: item.Code,
                color: item.Color,
                fieldNumber: item.FieldList?.length,
                fieldList: this.startExportFieldsData(item.FieldList)
            }
            EntityList.push(entityItem);
        });

        dataProjectJson.entities = EntityList;
        return JSON.stringify(dataProjectJson,replacer);
    }

    private createHTMLTAGTOGFile(doc:Document):string{
        const documentTitle = doc.title.replace('.txt','');
        var contentParagraphs:string = '';
        const textPlain = readBinaryContent(doc.textContent);    
        var paragraphs = textPlain.split('\n').filter(item => item !== '\r');
        paragraphs.forEach((paragraph, index) => {
            contentParagraphs += '<p id="s1p'+(index+1)+'">'+paragraph.replaceAll('\r','')+'</p> \n';
        });


        var template = '<!DOCTYPE html > '+
        ' <html id="'+documentTitle+'" data-origid="'+documentTitle+'" class="anndoc" data-anndoc-version="3.6" lang="" xml:lang="" xmlns="http://www.w3.org/1999/xhtml"> '+
          ' <head> '+
            ' <meta charset="UTF-8"/> '+
            ' <meta name="generator" /> '+
            ' <title>'+documentTitle+'</title> '+
          ' </head> '+
          ' <body> '+
            ' <article> '+
              ' <section data-type=""> '+
                ' <div class="content"> '+ 
                    contentParagraphs +
                ' </div> '+
              ' </section> '+
            '</article> '+
          ' </body> '+
        ' </html> ';    
        

        return template;
    }


    private getUniqueParagraphAnnotations(annotations:Annotation[], index: number):Annotation[]{
        var annotationsByParagraph = annotations.filter(item => item.paragraph === 's1p'+ (index + 1));
        const uniqueArray = annotationsByParagraph.filter((item, index, self) =>index === 
            self.findIndex((o) => o.start === item.start && o.end === item.end ) 
         );

        return uniqueArray;
    }
    private createJSONANNFile(annotations: Annotation[], document: Document, replacer:any)
    {
        const textPlain = readBinaryContent(document.textContent);    

        var annotationsList:Annotation[] =  [];
 
        var paragraphs = textPlain.split('\n').filter(item => item !== '\r');
        paragraphs.forEach((paragraph, index) => {
            const uniqueArray = this.getUniqueParagraphAnnotations(annotations, index);

             uniqueArray.forEach(item => {
                annotationsList.push(item);
             });
        });

        return JSON.stringify(annotationsList,replacer);

    }
    private createJSONTAGTOGFile(annotations: Annotation[], entities: Entity[], document: Document, replacer:any)
    { 
       const textPlain = readBinaryContent(document.textContent);    

       var TAGTOGAnnotations: any = {
        entities: []
       }; 

       var paragraphs = textPlain.split('\n').filter(item => item !== '\r');
       paragraphs.forEach((paragraph, index) => {
           
           const uniqueArray = this.getUniqueParagraphAnnotations(annotations, index);

           uniqueArray.forEach(item => {

            //add first entity
               var firstEntity = entities.find(entityItem => entityItem.Code === item.firstEntityCode);
             
               if(firstEntity !== undefined)
               {
                    var jsonFields = buildTagTogFieldsJSON(firstEntity, (item.fieldsFirstEntity)?item.fieldsFirstEntity:[], replacer);
                    var entityItem: any ={
                        classId: item.firstEntityCode,
                        part: item.paragraph,
                        relatedId: item.relatedTo,
                        relatedKey: item.relatedKey,
                        relatedText: item.relatedText,
                        offsets: [{
                            start: item.start,
                            text: item.text
                        }],
                        fields: JSON.parse(jsonFields)
                    };
                    TAGTOGAnnotations.entities.push(entityItem);
               } 

               
               //add second entity
               var secondentity = entities.find(entityItem => entityItem.Code === item.secondEntityCode);
               if(secondentity !== undefined)
               {
                    var jsonFields = buildTagTogFieldsJSON(secondentity, (item.fieldsSecondEntity)?item.fieldsSecondEntity:[], replacer);
                    var entityItem: any ={
                        classId: item.secondEntityCode,
                        part: item.paragraph,
                        relatedId: item.relatedTo,
                        relatedKey: item.relatedKey,
                        relatedText: item.relatedText,
                        offsets: [{
                            start: item.start,
                            text: item.text
                        }],
                        fields: JSON.parse(jsonFields)
                    };
                    TAGTOGAnnotations.entities.push(entityItem);
               }
           });
        });
    
       return JSON.stringify(TAGTOGAnnotations,replacer);
    }

    private createJSONFile(annotations: Annotation[], entities: Entity[], document: Document, replacer:any)
    { 
       const textPlain = readBinaryContent(document.textContent);    

       var NERAnnotations: NERAnnotation[] = [];  

       var paragraphs = textPlain.split('\n').filter(item => item !== '\r');
       paragraphs.forEach((paragraph, index) => {     
           const uniqueArray = this.getUniqueParagraphAnnotations(annotations, index);

           var NERAnn: NERAnnotation = {
            Anotacion: paragraph.replaceAll('\r',''),
            entities: []
           };

           uniqueArray.forEach(item => {

            //add first entity
               var entity = entities.find(entityItem => entityItem.Code === item.firstEntityCode);
               if(entity !== undefined)
               {
                    var entityItem: entityItem ={
                        start: item.start,
                        end: item.end,
                        entity: entity.Entity,
                        fields: (item.fieldsFirstEntity)?this.getFieldsByCode(entity,item.fieldsFirstEntity):[]
                    };
                    NERAnn.entities.push(entityItem);
               }

               //add second entity
               var secondentity = entities.find(entityItem => entityItem.Code === item.secondEntityCode);
               if(secondentity !== undefined)
               {
                    var entityItem: entityItem ={
                        start: item.start,
                        end: item.end,
                        entity: secondentity.Entity,
                        fields: (item.fieldsSecondEntity)?this.getFieldsByCode(secondentity,item.fieldsSecondEntity):[]
                    };
                    NERAnn.entities.push(entityItem);
               }
           });

           NERAnnotations.push(NERAnn);
        });
    
       return JSON.stringify(NERAnnotations,replacer);
    }

    private getFieldsByCode(entity:Entity, fieldsCode: string[]):string[]{
        var fieldsText:string[]=[];
       
            fieldsCode.forEach(item=>{
                if(entity.FieldList !== undefined){
                    var fieldObject = entity.FieldList.find(field => field.code === item);
                    if(fieldObject !== undefined)
                    {
                        fieldsText.push(fieldObject.name);
                    }
                }
            });

        
        return fieldsText;
    }

    private async createZipFile(zip:JSZip, prefix:string){
        
        const a = document.createElement('a');
        var dateNow = Date.now();
        const today = new Date(dateNow);

        const archive = await zip.generateAsync({type:"blob"});
        const url = window.URL.createObjectURL(archive);
        a.href = url;
        a.download = prefix + '_' + today.toISOString().replace('.','_') + '_' +'data_export.zip';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    private dowloadFile(data: BlobPart, fileName: string, mimeType: string){
        const blob = new Blob([data], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url); // Clean up the URL object
    }
}

